import { Link } from "react-router-dom";
import { HaevnLogo } from "./Navigation";

const footerNav = [
  { to: "/", label: "Home" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/cities", label: "Active Cities" },
  { to: "/pricing", label: "Pricing" },
];

const footerSecondary = [
  { to: "/about", label: "About" },
  { to: "/problem", label: "The Problem" },
  { to: "/why-apps-feel-broken", label: "Why Dating Apps Feel Broken" },
  { to: "/evolution", label: "Evolution of Dating" },
  { to: "/what-to-expect", label: "What to Expect" },
  { to: "/match", label: "Match Explained" },
  { to: "/connect", label: "Connect Explained" },
  { to: "/verification", label: "Verification" },
  { to: "/careers", label: "Careers" },
];

export default function Footer() {
  return (
    <footer className="bg-haevn-navy text-white py-10 px-6 md:px-12" data-testid="global-footer">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8 text-center md:text-left">
          {/* Brand */}
          <div>
            <HaevnLogo className="h-6 w-auto mb-3 mx-auto md:mx-0" color="#ffffff" />
            <p className="text-xs text-white/40 font-body leading-relaxed">
              Building meaningful connections, one city at a time.
            </p>
          </div>

          {/* Primary Links */}
          <div>
            <h4 className="font-subhead text-xs uppercase tracking-wider text-white/30 mb-3">Navigate</h4>
            <div className="space-y-2">
              {footerNav.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="block text-sm text-white/60 font-body hover:text-white transition-colors"
                  data-testid={`footer-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Secondary Links */}
          <div>
            <h4 className="font-subhead text-xs uppercase tracking-wider text-white/30 mb-3">Learn More</h4>
            <div className="space-y-2">
              {footerSecondary.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="block text-sm text-white/60 font-body hover:text-white transition-colors"
                  data-testid={`footer-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="font-subhead text-xs uppercase tracking-wider text-white/30 mb-3">Follow</h4>
            <div className="flex items-center gap-5 justify-center md:justify-start">
              <a href="https://www.instagram.com/haevnapp/#" target="_blank" rel="noopener noreferrer" className="text-[#9CA3AF] hover:text-white transition-colors duration-200" data-testid="footer-instagram" aria-label="Instagram">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
              </a>
              <a href="https://www.facebook.com/HAEVNAPP" target="_blank" rel="noopener noreferrer" className="text-[#9CA3AF] hover:text-white transition-colors duration-200" data-testid="footer-facebook" aria-label="Facebook">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
              </a>
              <a href="https://www.tiktok.com/@haevnapp" target="_blank" rel="noopener noreferrer" className="text-[#9CA3AF] hover:text-white transition-colors duration-200" data-testid="footer-tiktok" aria-label="TikTok">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"/></svg>
              </a>
              <a href="https://www.youtube.com/@haevntalks" target="_blank" rel="noopener noreferrer" className="text-[#9CA3AF] hover:text-white transition-colors duration-200" data-testid="footer-youtube" aria-label="YouTube">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19.1c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"/><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"/></svg>
              </a>
              <a href="https://www.reddit.com/r/HAEVNAPP/" target="_blank" rel="noopener noreferrer" className="text-[#9CA3AF] hover:text-white transition-colors duration-200" data-testid="footer-reddit" aria-label="Reddit">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M14.238 15.348c.085.084.085.221 0 .306-.465.462-1.194.687-2.231.687l-.008-.002-.008.002c-1.036 0-1.766-.225-2.231-.688-.085-.084-.085-.221 0-.305.084-.084.222-.084.307 0 .379.377 1.008.561 1.924.561l.008.002.008-.002c.915 0 1.544-.184 1.924-.561.085-.084.223-.084.307 0zm-3.44-2.418c0-.507-.414-.919-.922-.919-.509 0-.922.412-.922.919 0 .506.414.918.922.918.508 0 .922-.412.922-.918zm4.34-.919c-.509 0-.922.412-.922.919 0 .506.414.918.922.918.508 0 .922-.412.922-.918 0-.507-.414-.919-.922-.919zM12 2C6.478 2 2 6.477 2 12c0 5.522 4.478 10 10 10 5.523 0 10-4.478 10-10 0-5.523-4.477-10-10-10zm5.655 11.405c.012.136.018.273.018.411 0 2.095-2.44 3.795-5.45 3.795-3.01 0-5.45-1.7-5.45-3.795 0-.138.006-.275.018-.411a1.413 1.413 0 0 1-.567-1.136c0-.782.636-1.416 1.42-1.416.378 0 .722.15.972.394a7.262 7.262 0 0 1 3.46-.916l.663-3.113.021-.064a.216.216 0 0 1 .258-.155l2.21.492a1.003 1.003 0 0 1 .907-.577c.556 0 1.006.448 1.006 1.002 0 .553-.45 1.002-1.006 1.002-.553 0-1-.447-1.004-.998l-1.963-.437-.593 2.788a7.225 7.225 0 0 1 3.395.908c.25-.242.593-.39.967-.39.784 0 1.42.634 1.42 1.416 0 .46-.222.868-.567 1.13z"/></svg>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 text-center">
          <p className="text-xs text-white/25 font-body">
            &copy; 2025 HAEVN. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
